/* ============================================================
   Folded Hudson — arayuz scriptleri
   (Sepet mantigi ayri dosyada: cart.js)
   ============================================================ */

/* ---------- Duyuru seridi donusu ---------- */
(function () {
  var msgs = document.querySelectorAll('.announce__msg');
  if (msgs.length < 2) return;
  var i = 0;
  setInterval(function () {
    msgs[i].classList.remove('is-active');
    i = (i + 1) % msgs.length;
    msgs[i].classList.add('is-active');
  }, 4000);
})();

/* ---------- Arama paneli ---------- */
(function () {
  var panel = document.getElementById('searchPanel');
  var btn = document.querySelector('[aria-label="Search"]');
  if (!panel || !btn) return;

  function toggle() {
    var open = panel.classList.toggle('is-open');
    if (open) {
      setTimeout(function () {
        var i = document.getElementById('searchInput');
        if (i) i.focus();
      }, 260);
    }
  }
  btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); toggle(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') panel.classList.remove('is-open'); });
  document.addEventListener('click', function (e) {
    if (panel.classList.contains('is-open') && !panel.contains(e.target) && !btn.contains(e.target)) {
      panel.classList.remove('is-open');
    }
  });
})();

/* ---------- Hesap cekmecesi ---------- */
(function () {
  var d = document.getElementById('acctDrawer');
  var ov = document.getElementById('cartOverlay');
  var btn = document.querySelector('[aria-label="Account"]');
  if (!d || !btn) return;

  function open() { d.classList.add('is-open'); if (ov) ov.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function close() { d.classList.remove('is-open'); if (ov) ov.classList.remove('is-open'); document.body.style.overflow = ''; }

  btn.addEventListener('click', function (e) { e.preventDefault(); open(); });
  var x = document.getElementById('acctClose');
  if (x) x.addEventListener('click', close);
  if (ov) ov.addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
})();

/* ---------- Mobil menu ---------- */
(function () {
  var btn = document.querySelector('.menu-btn');
  var m = document.getElementById('mnav');
  var ov = document.getElementById('cartOverlay');
  if (!btn || !m) return;

  function open() { m.classList.add('is-open'); if (ov) ov.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); document.body.style.overflow = 'hidden'; }
  function close() { m.classList.remove('is-open'); if (ov) ov.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); document.body.style.overflow = ''; }

  btn.addEventListener('click', function (e) {
    e.preventDefault();
    m.classList.contains('is-open') ? close() : open();
  });
  var x = document.getElementById('mnavClose');
  if (x) x.addEventListener('click', close);
  if (ov) ov.addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
})();

/* ---------- Yorum rayi oklari ---------- */
(function () {
  var rail = document.getElementById('revRail');
  if (!rail) return;
  document.querySelectorAll('[data-rev]').forEach(function (b) {
    b.addEventListener('click', function () {
      var card = rail.querySelector('.review');
      var step = card ? card.getBoundingClientRect().width + 20 : 340;
      rail.scrollBy({ left: b.dataset.rev === 'next' ? step : -step, behavior: 'smooth' });
    });
  });
})();

/* ---------- Beden tablosu popup ---------- */
(function () {
  var chart = document.getElementById('chart');
  var openBtn = document.getElementById('openChart');
  var closeBtn = document.getElementById('closeChart');
  if (!chart || !openBtn) return;

  openBtn.addEventListener('click', function () { chart.setAttribute('open', ''); });
  if (closeBtn) closeBtn.addEventListener('click', function () { chart.removeAttribute('open'); });
  chart.addEventListener('click', function (e) { if (e.target === chart) chart.removeAttribute('open'); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') chart.removeAttribute('open'); });
})();

/* ---------- Ilgili urunler (Shopify onerileri) ---------- */
(function () {
  var el = document.querySelector('[data-recommendations]');
  if (!el) return;
  fetch(el.dataset.url)
    .then(function (r) { return r.text(); })
    .then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var sec = doc.querySelector('.section');
      if (sec) el.replaceWith(sec);
    })
    .catch(function () {});
})();
